import React, { useMemo } from 'react';
import * as ds from './dataService';
import { TaskRow } from 'modules/components/layer23';
import { StyledTable } from 'modules/components/layer24';
import { useParams } from 'react-router-dom';



export type TaskTableProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: TaskTableProps) => {
  const headers: string[] = [
    'ID',
    'Title',
    'Due',
    'Created',
    'Category',
    'Assignee',
    ''
  ];
  const params = useParams();
  const { data } = ds.useQuery(params.projectId ?? '');
  const rows = useMemo(() => {
    return data.map((node, i) => {
      return (
        <TaskRow.FC
          key={`row-${i}`}
          {...node}
        />
      );
    });
  }, [data]);
  return (
    <StyledTable.FC
      headers={headers}
      rows={rows}
    />
  );
};
